import Amplify from '@aws-amplify/core';
import { AUTH_TYPE } from 'aws-appsync';
import Cookies from 'cookies';
import { popPKCE } from 'auth';

import {
  OAUTH_DOMAIN,
  BASE_URL,
  IDENTITY_POOL_ID,
  REGION,
  USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID,
  PROTECTED_GRAPHQL_ENDPOINT,
} from 'settings';

export const AMPLIFY_CONFIG = {
  aws_appsync_graphqlEndpoint: PROTECTED_GRAPHQL_ENDPOINT,
  aws_appsync_region: REGION,
  aws_appsync_authenticationType: AUTH_TYPE.AWS_IAM,
  Auth: {
    identityPoolId: IDENTITY_POOL_ID,
    oauth: {
      domain: OAUTH_DOMAIN,
      redirectSignIn: BASE_URL,
      redirectSignOut: BASE_URL,
      responseType: 'code',
      scope: ['email', 'openid', 'aws.cognito.signin.user.admin'],
    },
    region: REGION,
    userPoolId: USER_POOL_ID,
    userPoolWebClientId: USER_POOL_WEB_CLIENT_ID,
    storage: Cookies.esCookieStorage,
  },
};

popPKCE();
Amplify.configure(AMPLIFY_CONFIG);
